/**
 * @fileoverview 全局指令入口
 */
import common from './common';

export default {
  ...common,
};
